import { transformPolygonCoordinates } from './transformPolygonCoordinates';

const transformPolygon = (transformCallback) => (multiPolygons) =>
  multiPolygons
    .map(transformCallback)
    .reduce((acc, polygons) => acc.concat(polygons), []);

export const transformTractsPolygon = transformPolygon(transformPolygonCoordinates);
export const transformMultiPolygon = transformPolygon(multiPolygon => {
  return multiPolygon.path.map(transformPolygonCoordinates);
});
